// extracted by mini-css-extract-plugin
module.exports = {"chessContainer":"style_chessContainer__7uJ_m"};